export const dqsDefaultLogic = {
	data: function() {
		return {
			totalScore: '',
			totalPossibleScore: '100',
			strokeColor: 'transparant',
			requestId: this.$route.params.routerSettings.requestId,
			apiUrl: env.dqsApiUrl, // eslint-disable-line
			viewApiCall: '',
			determinantScores: [],
			dqsIsVisible: false
		};
	},
	methods: {

		prepareTotalScore(dqsData){

			if(	!dqsData
				|| dqsData.length === 0
				|| typeof dqsData === 'undefined'){

					this.setDqsDataToNa('dqs data does not exist.');
					return;
			}

			if(Object.entries(dqsData).length === 0 && dqsData.constructor === Object){

				this.setDqsDataToNa('DQS calculator returned an empty object.');
				return;
			}

			this.dqsIsVisible = true;
			let roundScore = Math.floor(dqsData.totalScore.score);
			this.totalScore = roundScore.toString();
			this.totalPossibleScore = `${dqsData.totalScore.score} 100`;
			this.strokeColor = '#247ba0';
		},
		setDqsDataToNa(warn){

			this.totalPossibleScore = '100';
			this.totalScore = 'n/a';
			console.warn(warn);
		}
	}
};

export default {
	dqsDefaultLogic
}
